import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
    ApiErrorMessage,
    AppShellErrorService,
    AppShellErrorSeverity,
    AppShellErrorStatus,
    ErrorMessage,
} from '@priva/appshell';
import { PrivaNotificationsService } from '@priva/notifications';

@Injectable()
export class ErrorHandlerService {
    private readonly apiMessages$: Observable<ApiErrorMessage>;
    private readonly scriptMessages$: Observable<ErrorMessage>;

    constructor(
        private readonly errorService: AppShellErrorService,
        private readonly notificationsService: PrivaNotificationsService,
    ) {
        this.apiMessages$ = this.errorService.apiErrors;
        this.scriptMessages$ = this.errorService.scriptErrors;
    }

    initialize() {
        this.apiMessages$.subscribe((message: ApiErrorMessage) => this.handleApiMessages(message));
        this.scriptMessages$.subscribe((message: ErrorMessage) => this.handleScriptMessages(message));
    }

    private handleApiMessages(error: ApiErrorMessage) {
        if (error.status === AppShellErrorStatus.Resolved) {
            this.notificationsService.removeNotification(error.uuid);
            return;
        }

        switch (error.severity) {
            case AppShellErrorSeverity.Error:
                this.notificationsService.bar.error(
                    `${error.messageLabel} reported status code ${error.statusCode}`,
                    { behavior: 'tracked' },
                    error.uuid,
                );
                break;
            case AppShellErrorSeverity.Warning:
                this.notificationsService.bar.warning(
                    error.messageLabel,
                    { behavior: 'tracked' },
                    error.uuid,
                );
                break;
            default:
                break;
        }
    }

    private handleScriptMessages(message: ErrorMessage) {
        if (message.status === AppShellErrorStatus.Resolved) {
            this.notificationsService.removeNotification(message.uuid);
            return;
        }

        switch (message.severity) {
            case AppShellErrorSeverity.Error:
                this.notificationsService.bar.error(
                    message.messageLabel,
                    { behavior: 'tracked' },
                    message.uuid,
                );
                break;
            case AppShellErrorSeverity.Warning:
                this.notificationsService.bar.warning(
                    message.messageLabel,
                    { behavior: 'tracked' },
                    message.uuid,
                );
                break;
            default:
                break;
        }
    }
}
